import { removeQueryPart } from './removeQueryPart';

export function getTitle(url: string | undefined | null) {
  const withoutQuery = removeQueryPart(url);
  return withoutQuery
    ? withoutQuery.substring(withoutQuery.lastIndexOf('/') + 1)
    : undefined;
}
